import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import toast from "react-hot-toast";
import { BsArrowLeft } from "react-icons/bs";
import { API } from "../../constants/api";
import { errorMessage } from "../../utils/errorMessage";
import useAuthAxios from "../../utils/baseAxios";
import {
  MAX_E164_DIGITS,
  parseToE164Phone,
  sanitizePhoneInput,
} from "../../utils/phoneE164";
import ClipLoader from "react-spinners/ClipLoader";

const AddPhone = ({
  setOpenAddPhone,
  setOpenAddOtp,
  setOpenPhoneCheck,
}: {
  setOpenAddPhone: (value: boolean) => void;
  setOpenAddOtp: (value: boolean) => void;
  setOpenPhoneCheck: (value: boolean) => void;
}) => {
  const [phone, setPhone] = useState("");
  const axiosInstance = useAuthAxios();

  const handleVerify = async (data: any) => {
    const response = await axiosInstance.post(API.verifyPhone, data);
    return response.data;
  };
  const completeVerify = useMutation({
    mutationFn: handleVerify,
    onSuccess: (r) => {
      toast.success(r.message);
      setTimeout(() => {
        setOpenAddPhone(false);
        setOpenAddOtp(true);
      }, 1000);
    },
    onError: (error: any) => {
      toast.error(
        errorMessage((error?.data as any)?.message || String(error?.data))
      );
    },
  });
  const verifyPhone = () => {
    const formattedPhone = parseToE164Phone(phone);
    if (!formattedPhone) {
      toast.error(
        "Enter a valid number with country code (e.g. +447700900123) or Nigerian 08012345678"
      );
      return;
    }

    completeVerify.mutate({ phone_number: formattedPhone });
  };

  const canSubmit = parseToE164Phone(phone) !== null;
  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-6 items-center">
          <button
            onClick={() => {
              setOpenAddPhone(false);
            }}
          >
            <BsArrowLeft className="text-black dark:text-white text-[20px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-200 font-sora font-semibold text-[17px]">
            Update Number
          </h4>
        </div>
        <div className="w-full mt-8">
          <div className="mt-8">
            <h4 className="text-gray-900 dark:text-gray-100 text-[14px] ">
              Enter your phone number
            </h4>
            <input
              type="tel"
              inputMode="tel"
              autoComplete="tel"
              placeholder="e.g. +447700900123 or 08012345678"
              value={phone}
              maxLength={MAX_E164_DIGITS + 1}
              onChange={(e) => setPhone(sanitizePhoneInput(e.target.value))}
              className="text-gray-700 dark:text-gray-300 px-4  rounded-xl border border-gray-300 dark:border-gray-600 mt-2 bg-transparent w-full h-[48px]  text-[13px] text-left outline-none"
            />
          </div>
          <h4 className="text-gray-500 mt-4 italic text-center font-medium text-[14px]  px-6">
            A verification code will be sent to this number on{" "}
            <strong className="text-gray-800 dark:text-gray-200">
              Whatsapp
            </strong>
          </h4>
          <button
            disabled={!canSubmit}
            onClick={verifyPhone}
            className={`bg-secondary_button w-full mt-32  rounded-xl h-[48px] text-white font-medium ${
              !canSubmit ? "opacity-50" : ""
            }`}
          >
            {completeVerify.isPending ? (
              <ClipLoader color="#FFFFFF" size={30} />
            ) : (
              "Update"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddPhone;
